import { NgModule } from '@angular/core';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {LoadingModule} from 'ngx-loading';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPermissionsModule} from 'ngx-permissions';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { routes }              from './vendors.routing';
import { VendorsComponent }    from './vendors.component';
import { VendorEditComponent } from './vendor-edit/vendor-edit.component';
import { VendorService}        from "../../services/vendor.service";
import { PipesModule } from "../pipes/pipes.module";
import { MaterialModule } from "../material/material.module";
import {TableModule} from 'primeng/table';
import {MultiSelectModule} from 'primeng/multiselect';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { VendorAccessComponent } from './vendor-access/vendor-access.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        NgxDatatableModule,
        FormsModule,
        LoadingModule,
        NgbModule,
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        PipesModule,
        MaterialModule,
        TableModule,
        MultiSelectModule,
        ConfirmDialogModule
    ],
    providers: [VendorService],
    declarations: [ VendorsComponent, VendorEditComponent, VendorAccessComponent ]
})
export class VendorsModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/vendors/vendors.module.ts